import { getTheme } from '@fluentui/react';
import { helpbuttonStyle, convertToLocalStyle } from '@bingads-webui-campaign-react/common-styles';

const { palette } = getTheme();
export const getStyles = () => ({
  BrandListsPage: {
    padding: '25px 32px 0 32px',
    color: '#323138',
    '& .title': {
      margin: 0,
      fontSize: 26,
      fontWeight: 600,
      lineHeight: '27px',
    },
    '& .desc': {
      marginTop: 20,
    },
    '& .campaign-details-list-container': {
      marginTop: 16,
      '& .ms-DetailsRow-fields': {
        fontSize: 14,
      },
    },
    '& .ms-DetailsHeader .ms-DetailsHeader-cellName': {
      width: '100%',
    },
    '& .toolbar-container .toolbar': {
      '& .container-fluid': {
        paddingLeft: 0,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        '& .navbar-nav li': {
          marginRight: 16,
        },
      },
    },
    '& .toolbar-container .toolbar-edit .container-fluid .btn-link': {
      padding: '0 8px',
    },
    '& .applied-link': {
      marginLeft: 8,
    },
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
  },
});
